import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { SimpleLayout } from 'src/layouts/simple';

import { SplashScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

// Error
const Page500 = lazy(() => import('src/pages/error/500'));
const Page403 = lazy(() => import('src/pages/error/403'));
const Page404 = lazy(() => import('src/pages/error/404'));
// Invite
const GroupInvitePage = lazy(() => import('src/pages/invite/group-invite'));
// Referral
const ReferralPage = lazy(() => import('src/pages/referral'));

// ----------------------------------------------------------------------

export const mainRoutes: RouteObject[] = [
  {
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      {
        path: 'error',
        children: [
          { path: '500', element: <Page500 /> },
          { path: '404', element: <Page404 /> },
          { path: '403', element: <Page403 /> },
        ],
      },
      {
        path: 'invite/:inviteCode',
        element: (
          <AuthGuard>
            <SimpleLayout>
              <GroupInvitePage />
            </SimpleLayout>
          </AuthGuard>
        ),
      },
      {
        path: 'referral',
        element: (
          <SimpleLayout>
            <ReferralPage />
          </SimpleLayout>
        ),
      },
    ],
  },
];
